module.exports = __webpack_public_path__ + "static/media/agent-icon.32cd6c34.svg";